import { Form } from "antd";
import BaseModalForm from "components/BaseModalForm";
import message from "components/CustomMessage";
import moment from "moment";
import React, { forwardRef } from "react";
import FindingAPI from "restAPI/FindingAPI";
import { FieldTypes } from "utils/formUtils";
import Vocabulary, { getVocabulary } from "components/Vocabulary";
import { disablePastDates } from "utils/dateUtils";

const FindingDueDateForm = forwardRef(({finding,afterClose},ref) => {

    const [form] = Form.useForm();

    const changeDueDate = async () => {
        const data = form.getFieldsValue();
        const findingId = [finding.id];
        let params = {
            notes: data.comment,
            slaDueDate: data.slaDueDate.endOf("D").utc().format(),
        };
        params.findingIds = findingId;
        await FindingAPI.bulk.dueDate(params).promise;
        message.success(<><Vocabulary name="resolution"/> Due Date updated successfully. Please check after some time.</>);
    };

    const fields = [
        {
            name: "slaDueDate",
            label: `${getVocabulary("resolution")} Due Date`,
            type: FieldTypes.DATE,
            colSpan: 10,
            required: true,
            props: {
              disabledDate: disablePastDates,
              autoFocus: true
            },
        },
        {
            name: "comment",
            label: "Comment",
            type: FieldTypes.TEXT_AREA,
            required: true,
            customLengthRule: {
                max: 1000,
                message: "Maximum length is 1000 characters"
            },
        },
    ]

    const modalProps = {
        title: `Update ${getVocabulary("resolution")} Due Date`,
        okText: "Save",
    }

    return (
      <BaseModalForm 
          form={form}
          modalProps={modalProps} 
          fields={fields} 
          ref={ref} 
          initialValues={{slaDueDate: finding.slaDueDate && moment(finding.slaDueDate) }} 
          onOk={changeDueDate} 
          afterClose={afterClose}>
      </BaseModalForm>
    )

})

export default FindingDueDateForm;
